import { useNavigate } from "react-router-dom";
import { WeekendDTO } from "../dtos/WeekendDTO";
import { Mode } from "../lib/globalEnums";

export default function WeekendTeaser(props: {
  weekend: WeekendDTO,
  active?: boolean
  mode?: Mode
}) {
  const navigate = useNavigate();
  let className = `weekendTeaser w3-button w3-left-align ${(props.active || props.mode === Mode.extended) ? 'w3-white' : ''} ${(props.mode === Mode.extended) ? 'flex-grow w3-card' : ''}`
  
  return (
    <button
      className={className}
      onClick={() => {
        navigate(props.weekend.getLink());
      }}
    >
      <div className="w3-bold">{props.weekend.getDisplayName()}</div>
      <div>{props.weekend.getHumanDate()}</div>
      {
        props.mode === Mode.extended &&
        <>
          <div>{props.weekend.getFullTime()}</div>
          <div>{props.weekend.location}, {props.weekend.country_name}</div>
        </>
      }
    </button>
  );
}
